import CapCheck from "@/components/CapCheck";
import MemberCheck from "@/components/MemberCheck";
import SacCheck from "@/components/SacCheck";
import StaffCheck from "@/components/StaffCheck";
import { StepContext } from "@/contexts/StepContext";
import { Grid, Paper } from "@mui/material";
import { Field, Select, Text } from "@ngt/forms";
import { FC } from "react";
import RegistrationField from '../../RegistrationField';


interface IEarlyBird{
    earlyBird?: boolean;
}
const RegistrationStepOne: FC<IEarlyBird> = ({earlyBird = false}) => {
    return (
        <StepContext.Provider value={0}>
            <Paper
                sx={{ p: 4, pt: 0, mt: { xs: 1, md: 3 } }}
            >
                <Grid 
                    container
                    columnSpacing={4}
                >
                    <Grid
                        item
                        xs={12}
                        md={4}
                        lg={4}
                        xl={2}
                        mt={4}
                    >
                        <RegistrationField
                            label="Title"
                            propertyPath="title"
                            component={Select}
                            FormControlProps={{
                                variant: "standard"
                            }}
                            disabled={earlyBird}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={4}
                        lg={4}
                        xl={5}
                        mt={4}
                    >
                        <RegistrationField
                            label="First Name"
                            propertyPath="firstName"
                            component={Text}
                            variant="standard"
                            disabled={earlyBird}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={4}
                        lg={4}
                        xl={5}
                        mt={4}
                    >
                        <RegistrationField
                            label="Last Name"
                            propertyPath="lastName"
                            component={Text}
                            variant="standard"
                            disabled={earlyBird}
                        />
                    </Grid>
                </Grid>
                    <Grid 
                        container
                        columnSpacing={4}
                        mt={4}
                    >
                    { !earlyBird && (
                        <Grid 
                            item
                            xs={12}
                        >
                            <MemberCheck/>
                            <br></br>
                            <StaffCheck/>
                            <br></br>
                            <SacCheck/> 
                            <br></br>
                            <CapCheck/>                       
                            <Field
                                propertyPath="member"
                            /> 
                        </Grid>
                    )}
                </Grid>
            </Paper>
        </StepContext.Provider>
        
    );

};


export default RegistrationStepOne;